import apiService from "./ApiService"
import { createQS } from "./Utils"

export const StatusDescarteEnum = {
  AGUARDANDO_ASSINATURA: 'aguardando_assinatura',
  ASSINADO: 'assinado',
  AGUARDANDO_RETORNO_COMPROVANTE: 'aguardando_retorno_comprovante',
  FINALIZADO: 'finalizado',
  CANCELADO: 'cancelado'
}

export const StatusDescarteEnumList = [
  { id: StatusDescarteEnum.AGUARDANDO_ASSINATURA, nome: getStatusDescarte(StatusDescarteEnum.AGUARDANDO_ASSINATURA) },
  { id: StatusDescarteEnum.ASSINADO, nome: getStatusDescarte(StatusDescarteEnum.ASSINADO) },
  { id: StatusDescarteEnum.AGUARDANDO_RETORNO_COMPROVANTE, nome: getStatusDescarte(StatusDescarteEnum.AGUARDANDO_RETORNO_COMPROVANTE) },
  { id: StatusDescarteEnum.FINALIZADO, nome: getStatusDescarte(StatusDescarteEnum.FINALIZADO) },
  { id: StatusDescarteEnum.CANCELADO, nome: getStatusDescarte(StatusDescarteEnum.CANCELADO) }
]

export function getStatusDescarte(status) {
  switch (status) {
    case StatusDescarteEnum.AGUARDANDO_ASSINATURA:
      return 'Aguardando Assinatura';
    case StatusDescarteEnum.ASSINADO:
      return 'Assinado';
    case StatusDescarteEnum.AGUARDANDO_RETORNO_COMPROVANTE:
      return 'Aguardando Retorno de Comprovante';
    case StatusDescarteEnum.FINALIZADO:
      return 'Finalizado';
    case StatusDescarteEnum.CANCELADO:
      return 'Cancelado';
    default:
      return status;
  }
}

export const MotivoDescarteEnum = {
  OBSOLETO: 'obsoleto',
  QUEBRADO: 'quebrado',
  SUBSTITUICAO: 'substituicao',
  EXCESSO_ESTOQUE: 'excesso_estoque',
  OUTRO: 'outro'
}

export const MotivoDescarteEnumList = [
  { id: MotivoDescarteEnum.OBSOLETO, nome: getMotivoDescarte(MotivoDescarteEnum.OBSOLETO) },
  { id: MotivoDescarteEnum.QUEBRADO, nome: getMotivoDescarte(MotivoDescarteEnum.QUEBRADO) },
  { id: MotivoDescarteEnum.SUBSTITUICAO, nome: getMotivoDescarte(MotivoDescarteEnum.SUBSTITUICAO) },
  { id: MotivoDescarteEnum.EXCESSO_ESTOQUE, nome: getMotivoDescarte(MotivoDescarteEnum.EXCESSO_ESTOQUE) },
  { id: MotivoDescarteEnum.OUTRO, nome: getMotivoDescarte(MotivoDescarteEnum.OUTRO) }
]

export function getMotivoDescarte(motivo, outro) {
  switch (motivo) {
    case MotivoDescarteEnum.OBSOLETO:
      return 'Obsoleto';
    case MotivoDescarteEnum.QUEBRADO:
      return 'Quebrado';
    case MotivoDescarteEnum.SUBSTITUICAO:
      return 'Substituição';
    case MotivoDescarteEnum.EXCESSO_ESTOQUE:
      return 'Excesso de Estoque';
    case MotivoDescarteEnum.OUTRO:
      return outro ? `Outro: ${outro}` : 'Outro';
    default:
      return motivo;
  }
}

export const DestinacaoMaterialDescarteEnum = {
  DESCARTE_HOMOLOGADO: 'descarte_homologado',
  DEVOLUCAO_PROPRIETARIO: 'devolucao_proprietario',
  REUTILIZACAO: 'reutilizacao'
}

export const DestinacaoMaterialDescarteEnumList = [
  { id: DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO, nome: getDestinacaoMaterialDescarte(DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO) },
  { id: DestinacaoMaterialDescarteEnum.DEVOLUCAO_PROPRIETARIO, nome: getDestinacaoMaterialDescarte(DestinacaoMaterialDescarteEnum.DEVOLUCAO_PROPRIETARIO) },
  { id: DestinacaoMaterialDescarteEnum.REUTILIZACAO, nome: getDestinacaoMaterialDescarte(DestinacaoMaterialDescarteEnum.REUTILIZACAO) }
]

export function getDestinacaoMaterialDescarte(destinacao) {
  switch (destinacao) {
    case DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO:
      return 'Descarte Homologado';
    case DestinacaoMaterialDescarteEnum.DEVOLUCAO_PROPRIETARIO:
      return 'Devolução ao Proprietário';
    case DestinacaoMaterialDescarteEnum.REUTILIZACAO:
      return 'Reutilização';
    default:
      return destinacao;
  }
}

class DescarteService {
  async get(idContrato, idEmpresa, motivoDescarte, destinacaoMaterial, status, termo, pagina, dataInicio, dataFim) {
    try {
      const qs = createQS({ idEmpresa, motivoDescarte, destinacaoMaterial, status, termo, pagina, dataInicio, dataFim })
      return await apiService.get(`contrato/${idContrato}/descarte?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(idContrato, data) {
    try {
      return await apiService.post(`contrato/${idContrato}/descarte`, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(idContrato, idDescarte) {
    try {
      return await apiService.delete(`contrato/${idContrato}/descarte/${idDescarte}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async getDocumentoGerado(idContrato, idDescarte) {
    try {
      const res = await apiService.get(`contrato/${idContrato}/descarte/${idDescarte}/documento-gerado`)
      if (res.success) {
        return res.data.signedUrl
      } else {
        throw new Error('Erro ao baixar o documento gerado')
      }
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getDocumentoAssinado(idContrato, idDescarte) {
    try {
      const res = await apiService.get(`contrato/${idContrato}/descarte/${idDescarte}/documento-assinado`)
      if (res.success) {
        return res.data.signedUrl
      } else {
        throw new Error('Erro ao baixar o documento assinado')
      }
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getCertificadoDescarte(idContrato, idDescarte) {
    try {
      const res = await apiService.get(`contrato/${idContrato}/descarte/${idDescarte}/certificado-descarte`)
      if (res.success) {
        return res.data.signedUrl
      } else {
        throw new Error('Erro ao baixar o certificado de descarte')
      }
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async finalize(idContrato, idDescarte, arquivoAssinado, arquivoCertificado) {
    try {
      return await apiService.post(`contrato/${idContrato}/descarte/${idDescarte}/finalize`, {
        arquivoAssinado,
        arquivoCertificado,
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const descarteService = new DescarteService()
export default descarteService